import * as React from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';
import { useNewbuildingPolygonsContext } from 'shared/map-search/containers/Map/MapLayers/NewbuildingsPolygons/context';
import { selectActiveNewbuildingPolygon } from 'shared/map-search/selectors/newbuildingPolygons';
import { IActiveNewbuildingPolygon } from 'shared/map-search/types/map/newbuildingPolygon';
import { IApplicationState } from 'shared/map-search/types/redux';

export const ActivePolygonSync: React.FC = () => {
  const { newbuildingsPolygonsManager } = useNewbuildingPolygonsContext();
  const { config } = useApplicationContext();
  const activePolygon = useSelector<IApplicationState, IActiveNewbuildingPolygon>(selectActiveNewbuildingPolygon);

  const isEnabled = config.get('Newbuilding.NewbuildingPin.Enabled');

  React.useEffect(() => {
    if (isEnabled) {
      newbuildingsPolygonsManager.setActivePolygon(activePolygon.newbuildingId ?? null);
    }
  }, [activePolygon.newbuildingId, newbuildingsPolygonsManager, isEnabled]);

  return null;
};
